import {
  ReturnMethodsApi,
  type ValidateAddressRequest,
  type ValidateAddressResponse
} from '@itsrever/returns-api-types'
import { axiosInstance } from '@/redux/api/api-configuration'

const returnMethodsApi = new ReturnMethodsApi(
  undefined,
  undefined,
  axiosInstance
)

// The shopper is waiting on this with the form in front of them, so give up long
// before the shared axios timeout: a slow answer is worth less than no answer.
export const ADDRESS_VALIDATION_TIMEOUT_MS = 2_500

export const validateAddress = async (
  ecommerceID: string,
  request: ValidateAddressRequest
): Promise<ValidateAddressResponse> => {
  const { data } = await returnMethodsApi.validateAddress(
    { ecommerceID, validateAddressRequest: request },
    { timeout: ADDRESS_VALIDATION_TIMEOUT_MS }
  )
  return data
}
